import React from 'react';

// 根据实际 shaixuan.svg 内容填充 path（示例为占位符，需替换为真实 SVG 路径）
const SaveIcon = ({name, color}) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={name} width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path d="M19.65 3H4.35C3.60441 3 3 3.60441 3 4.35V19.65C3 20.3956 3.60441 21 4.35 21H19.65C20.3956 21 21 20.3956 21 19.65V4.35C21 3.60441 20.3956 3 19.65 3Z" stroke={color} strokeWidth="1.25" strokeLinejoin="round"/>
    <path d="M16 3V12H7.5V3H16Z" stroke={color} strokeWidth="1.25" strokeLinejoin="round"/>
    <path d="M13 6.5V8.5" stroke={color} strokeWidth="1.25" strokeLinecap="round"/>
    <path d="M5.5 3H18.0007" stroke={color} strokeWidth="1.25" strokeLinecap="round"/>
  </svg>
);

export default SaveIcon;
